import {Injectable} from '@angular/core';
import {Observable, of} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class UvtService {
    private _uvtValues = [
        {
            vigencia: 2025,
            valor: 49799,
            patrimonio: 4500,
            ingresos: 1400
        },
        {
            vigencia: 2024,
            valor: 47065,
            patrimonio: 4500,
            ingresos: 1400
        },{
            vigencia: 2023,
            valor: 42412,
            patrimonio: 4500,
            ingresos: 1400
        }
    ];
    constructor() {

    }


    get uvtValues(): any {
        return this._uvtValues;
    }

    set uvtValues(value: any) {
        this._uvtValues = value;
    }

    public getValuesUvt(): Observable<[]> {
        //return this.httpClient.get<[]>('/consultarenta/assets/data/uvt.json');
        return of(this.uvtValues);
    }

}
